import { checkPathBetweenShape } from "@adactiveasia/adsign-map";
import imgPlaceholder from "./assets/images/placeholder.png";
import logo from "./assets/images/botanic-logo.png";
import { filter } from "lodash";

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const getPoiAsset = (config, poi) => {
  if (!poi?.logo || !config) {
    return imgPlaceholder;
  }

  if (config?.platformType === "kiosk") {
    return `/poi/${poi.logo}`;
  }

  return `${config?.assetUrl}/poi/${poi.logo}`;
};

export const getInformationAsset = (config, path, placeholder) => {
  if (!path || !config) {
    return placeholder ?? imgPlaceholder;
  }
  return `${config?.assetUrl}/information/${path}`;
};

export const getMediaAsset = (config, path) => {
  if (!path || !config) {
    return imgPlaceholder;
  }

  if (config?.platformType === "kiosk") {
    return `/media/${path}`;
  }

  return `${config?.assetUrl}/media/${path}`;
};

export const getMediaTag = (mediaTags, tags) => {
  let stringTag = "";

  mediaTags?.forEach((tag) => {
    const filteredTag = tags?.filter((e) => e._id === tag);
    stringTag += filteredTag?.[0]?.name + ", ";
  });

  if (stringTag.length > 1) {
    stringTag = stringTag?.slice(0, -2);
  }

  return stringTag;
};

export const getAppLogo = (config, path) => {
  if (!path || !config) {
    return logo;
  }

  return `${config?.assetUrl}/information/${path}`;
};

export const getFormattedDate = (timestamp = Date.now()) => {
  const date = new Date(timestamp);

  // Get day with ordinal suffix
  const day = date.getDate();
  const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  // Get month name
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const month = months[date.getMonth()];

  // Get year
  const year = date.getFullYear();

  // Get 12-hour time
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours ? hours : 12;

  return `${day}${getOrdinalSuffix(
    day
  )} ${month} ${year}, ${hours}:${minutes}${ampm}`;
};

function parseDateTimeEventSchedule(dateStr, timeStr) {
  let timeTrim = timeStr;
  if (timeStr === null || timeStr === undefined) {
    timeTrim = "12am";
  }

  // dateStr: "13 August 2025" or "22 Aug 2025"
  // timeStr: "9am" or "6pm"

  const [day, monthName, year] = dateStr.split(" ");

  // Support both full and abbreviated month names
  const monthMap = {
    // Full names
    january: 0,
    february: 1,
    march: 2,
    april: 3,
    may: 4,
    june: 5,
    july: 6,
    august: 7,
    september: 8,
    october: 9,
    november: 10,
    december: 11,
    // Abbreviated names
    jan: 0,
    feb: 1,
    mar: 2,
    apr: 3,
    may: 4,
    jun: 5,
    jul: 6,
    aug: 7,
    sep: 8,
    oct: 9,
    nov: 10,
    dec: 11,
  };

  const monthIndex = monthMap[monthName.toLowerCase()];

  if (monthIndex === undefined) {
    throw new Error(`Invalid month name: ${monthName}`);
  }

  // Parse time (9am, 6pm)
  const timeMatch = timeTrim.match(/(\d+)(?::(\d+))?\s*(am|pm)/i);
  if (!timeMatch) {
    throw new Error(`Invalid time format: ${timeTrim}`);
  }

  let hour = parseInt(timeMatch[1], 10);
  let minute = timeMatch[2] ? parseInt(timeMatch[2], 10) : 0;
  const ampm = timeMatch[3].toLowerCase();

  if (ampm === "pm" && hour !== 12) hour += 12;
  if (ampm === "am" && hour === 12) hour = 0;

  return new Date(Number(year), monthIndex, Number(day), hour, minute);
}

export const isNowInRange = (
  input,
  filterType = "range",
  startDate,
  endDate
) => {
  if (!input) return true;
  const [datePart, timePart] = input.split(";");
  const [startTimeStr, endTimeStr] = timePart.split(" - ").map((s) => s.trim());

  let startDateTime, endDateTime;
  const now = new Date();

  if (datePart.includes(" - ")) {
    const [startDateStr, endDateStr] = datePart
      .split(" - ")
      .map((s) => s.trim());
    startDateTime = parseDateTimeEventSchedule(startDateStr, startTimeStr);
    endDateTime = parseDateTimeEventSchedule(endDateStr, endTimeStr);
  } else {
    startDateTime = parseDateTimeEventSchedule(datePart.trim(), startTimeStr);
    endDateTime = parseDateTimeEventSchedule(datePart.trim(), endTimeStr);
    console.log(
      datePart,
      startTimeStr,
      startDateTime,
      endDateTime,
      "startDateTime"
    );
  }

  if (filterType === "This Week") {
    const currentDay = now.getDay();
    const daysToMonday = currentDay === 0 ? 6 : currentDay - 1;

    const startOfWeek = new Date(now);
    startOfWeek.setDate(now.getDate() - daysToMonday);
    startOfWeek.setHours(0, 0, 0, 0);

    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    endOfWeek.setHours(23, 59, 59, 999);

    if (datePart.includes(" - ")) {
      return startDateTime <= endOfWeek && endDateTime >= startOfWeek;
    } else {
      const eventDate = new Date(startDateTime);
      eventDate.setHours(0, 0, 0, 0);

      return eventDate >= startOfWeek && eventDate <= endOfWeek;
    }
  } else if (filterType === "This Month") {
    // Get start and end of current month
    const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    startOfMonth.setHours(0, 0, 0, 0);

    const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    endOfMonth.setHours(23, 59, 59, 999);

    if (datePart.includes(" - ")) {
      // Check if the event overlaps with this month
      return startDateTime <= endOfMonth && endDateTime >= startOfMonth;
    } else {
      // Check if the event day falls within this month
      const eventDate = new Date(startDateTime);
      eventDate.setHours(0, 0, 0, 0);

      return eventDate >= startOfMonth && eventDate <= endOfMonth;
    }
  } else if (filterType === "Custom Dates") {
    const date1 = new Date(startDate);
    const date2 = new Date(endDate);

    if (datePart.includes(" - ")) {
      return date1 >= startDateTime && date2 <= endDateTime;
    } else {
      console.log(startDateTime, " endDate");
      return date1 <= startDateTime && date2 >= startDateTime;
    }
  } else if (filterType === "Today") {
    if (datePart.includes(" - ")) {
      const [startDateStr, endDateStr] = datePart
        .split(" - ")
        .map((s) => s.trim());
      startDateTime = parseDateTimeEventSchedule(startDateStr, startTimeStr);
      endDateTime = parseDateTimeEventSchedule(endDateStr, endTimeStr);
      const now = new Date();
      return now >= startDateTime && now <= endDateTime;
    } else {
      startDateTime = parseDateTimeEventSchedule(datePart.trim(), startTimeStr);
      endDateTime = parseDateTimeEventSchedule(datePart.trim(), endTimeStr);
      const now = new Date();
      return now <= startDateTime;
    }
  }

  return false;
};

// export const isNowInRange = (input) => {
//   if (!input) return true;
//   const [datePart, timePart] = input.split(";");
//   const [startTimeStr, endTimeStr] = timePart.split(" - ").map((s) => s.trim());

//   let startDateTime, endDateTime;

//   if (datePart.includes(" - ")) {
//     // Multiple days
//     const [startDateStr, endDateStr] = datePart
//       .split(" - ")
//       .map((s) => s.trim());
//     startDateTime = parseDateTimeEventSchedule(startDateStr, startTimeStr);
//     endDateTime = parseDateTimeEventSchedule(endDateStr, endTimeStr);
//     const now = new Date();
//     return now >= startDateTime && now <= endDateTime;
//   } else {
//     startDateTime = parseDateTimeEventSchedule(datePart.trim(), startTimeStr);
//     endDateTime = parseDateTimeEventSchedule(datePart.trim(), endTimeStr);
//     const now = new Date();
//     return now <= startDateTime;
//   }
// };

const dateTimeRegex =
  /^(?:(\d{1,2}\s+\w{3}\s+\d{4})(?:\s*-\s*(\d{1,2}\s+\w{3}\s+\d{4}))?\s*;\s*)?(\d{1,2}(?:am|pm)\s*-\s*\d{1,2}(?:am|pm))$/i;

export const parseDateTime = (input) => {
  const match = input?.match(dateTimeRegex);

  if (match) {
    const startDate = match[1] || null; // Start date part (null if not present)
    const endDate = match[2] || null; // End date part (null if not present)
    const time = match[3]; // Time part

    return {
      date: endDate ? startDate + " - " + endDate : startDate,
      time: time,
      original: input,
    };
  }

  return null;
};
